const CartoesCredito = () => import('@/views/CartoesCredito.vue');
const CartoesCreditoCadastrar = () => import('@/views/CartoesCreditoCadastrar.vue');
const ContasBancaria = () => import('@/views/ContasBancarias.vue');
const ContasBancariaCadastrar = () => import('@/views/ContasBancariasCadastrar.vue');

const routes = [
  {
    path: '/meu-perfil/cartoes-credito',
    name: 'cartoes-credito',
    component: CartoesCredito,
    meta: {
      title: 'Cartões de Crédito',
    },
  },
  {
    path: '/meu-perfil/cartoes-credito/cadastrar',
    name: 'cartoes-credito-cadastrar',
    beforeEnter(to, from, next) {
      if (from.name === 'cartoes-credito' || from.name === 'forma-pagamento') {
        return next();
      }
      return next('/meu-perfil/cartoes-credito');
    },
    component: CartoesCreditoCadastrar,
    meta: {
      title: 'Cadastrar Cartão de Crédito',
    },
  },
  {
    path: '/meu-perfil/contas-bancarias',
    name: 'contas-bancarias',
    component: ContasBancaria,
    meta: {
      title: 'Contas Bancárias',
    },
  },
  {
    path: '/meu-perfil/contas-bancarias/cadastrar',
    name: 'contas-bancarias-cadastrar',
    beforeEnter(to, from, next) {
      if (from.name === 'cartoes-credito' || from.name === 'forma-pagamento') {
        return next();
      }
      return next('/meu-perfil/contas-bancarias');
    },
    component: ContasBancariaCadastrar,
    meta: {
      title: 'Cadastrar Conta Bancária',
    },
  },
];

export default routes;
